/**
 * UserLoggedMenu component.
 * @module components/ItaliaTheme/Header/HeaderSlim/ArLogin
 */

import React from 'react';
//import { Link } from 'react-router-dom';
//import { defineMessages, useIntl } from 'react-intl';

//import { LinkListItem } from 'design-react-kit/dist/design-react-kit';

//const messages = defineMessages({});

const UserLoggedMenu = () => {
  //const intl = useIntl();

  return <></>;

  /*Example:

  return (
    <>
      <LinkListItem
        to="/ar/i-miei-servizi"
        title={intl.formatMessage(messages.ar_i_miei_servizi)}
        tag={Link}
      >
        <span>{intl.formatMessage(messages.ar_i_miei_servizi)}</span>
      </LinkListItem>
      <LinkListItem
        to="/ar/le-mie-pratiche"
        title={intl.formatMessage(messages.ar_le_mie_pratiche)}
        tag={Link}
      >
        <span>{intl.formatMessage(messages.ar_le_mie_pratiche)}</span>
      </LinkListItem>
      <LinkListItem
        to="/ar/notifiche"
        title={intl.formatMessage(messages.notifiche)}
        tag={Link}
      >
        <span>{intl.formatMessage(messages.notifiche)}</span>
      </LinkListItem>
    </>
  );
  */
};

export default UserLoggedMenu;
